import { render, staticRenderFns } from "./sectionViewOpen.vue?vue&type=template&id=21146459&scoped=true&"
import script from "./sectionViewOpen.vue?vue&type=script&lang=js&"
export * from "./sectionViewOpen.vue?vue&type=script&lang=js&"
import style0 from "./sectionViewOpen.vue?vue&type=style&index=0&id=21146459&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21146459",
  null
  
)

export default component.exports